module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bT6AF"))).then(() => parcelRequire('d0iPb'));